import * as React from 'react';
import Alert, { AlertCategoryEnum } from './Alert';

export const NoStudyBrickwall = () => (
    <Alert category={AlertCategoryEnum.Danger} show={true}>
        There are no studies set up, create a study first
    </Alert>
);
